<div class="rv-rows small">
  <div class="rv-flex flex-fs">
    <riv-icon
      *ngIf="locked"
      [name]="'Lock'"
      [rivTooltip]="lockedHelpText"
    ></riv-icon>
    <deprecated-select-dropdown
      class="rv-skinny-grow"
      *ngIf="!hideOperators"
      [options]="_.operatorOptions"
      [selectedOptionId]="_.selectedOperator"
      (selectedOptionIdChange)="_.setSelectedOperator($event)"
      [analyticsEvents]="{ select: analyticsEvents.changeFilter }"
      [disabled]="locked"
    ></deprecated-select-dropdown>
  </div>
  <div class="rv-flex flex-fs">
    <riv-icon
      *ngIf="locked"
      [name]="'Lock'"
      [rivTooltip]="lockedHelpText"
    ></riv-icon>
    <deprecated-select-dropdown
      class="rv-skinny-grow"
      *ngIf="_.showDropdown"
      [placeholder]="placeholder"
      [filterable]="optionsFilterable"
      [multiSelect]="false"
      [options]="options"
      [optionsLoader]="optionsLoader"
      [selectedOptionId]="_.filterId"
      (selectedOptionIdChange)="_.setFilterId($event)"
      [selectedEnabled]="selectedEnabled"
      [analyticsEvents]="{
        select: analyticsEvents.changeFilter,
        multiSelect: analyticsEvents.changeFilter
      }"
      [disabled]="locked"
    ></deprecated-select-dropdown>
  </div>
</div>
